function getHeaders(csrfToken, isJson = true) {
  const headers = { 'X-CSRF-Token': csrfToken };
  if (isJson) headers['Content-Type'] = 'application/json';
  return headers;
}

export async function createDraft(csrfToken) {
  const res = await fetch('/api/admin/articles/drafts', {
    method: 'POST',
    headers: getHeaders(csrfToken),
    body: JSON.stringify({})
  });
  return res.json();
}

export async function autosaveArticle(csrfToken, articleId, autosaveToken, fields) {
  const hasFile = fields.image instanceof File;

  let body;
  let headers;

  if (hasFile) {
    const formData = new FormData();
    formData.append('autosave_token', autosaveToken);
    Object.entries(fields).forEach(([key, value]) => {
      if (key === 'tag_list' || key === 'category_list') {
        (value || []).forEach(v => formData.append(`article[${key}][]`, v));
      } else if (key === 'image' && value instanceof File) {
        formData.append('article[image]', value);
      } else if (value !== undefined && value !== null) {
        formData.append(`article[${key}]`, value);
      }
    });
    body = formData;
    headers = { 'X-CSRF-Token': csrfToken };
  } else {
    const articleFields = Object.assign({}, fields);
    // Send remove_image as a string for Rails param parsing
    if (articleFields.remove_image) articleFields.remove_image = 'true';
    // Don't send image_url — it's read-only on the server
    delete articleFields.image_url;
    body = JSON.stringify({ autosave_token: autosaveToken, article: articleFields });
    headers = getHeaders(csrfToken);
  }

  const res = await fetch(`/api/admin/articles/${articleId}/autosave`, {
    method: 'PATCH',
    headers,
    body
  });
  return { data: await res.json(), status: res.status };
}

export async function publishArticle(csrfToken, articleId, autosaveToken) {
  const res = await fetch(`/api/admin/articles/${articleId}/publish`, {
    method: 'POST',
    headers: getHeaders(csrfToken),
    body: JSON.stringify({ autosave_token: autosaveToken })
  });
  return { data: await res.json(), status: res.status };
}

export async function completeOnboarding(csrfToken) {
  const res = await fetch('/api/admin/articles/onboarding', {
    method: 'PATCH',
    headers: getHeaders(csrfToken),
    body: JSON.stringify({})
  });
  return res.json();
}

export async function uploadEditorFile(csrfToken, file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch('/api/admin/uploads', {
    method: 'POST',
    headers: { 'X-CSRF-Token': csrfToken },
    body: formData
  });
  return { data: await res.json(), status: res.status };
}

export async function fetchArticle(articleId) {
  var res = await fetch('/api/admin/articles/' + encodeURIComponent(articleId));
  var json = await res.json();
  return json.article || json;
}

export async function searchDoctors(query) {
  var url = '/api/doctors';
  if (query) url += '?q=' + encodeURIComponent(query);
  var res = await fetch(url);
  var data = await res.json();
  var doctors = Array.isArray(data) ? data : (data.doctors || []);
  // Shuffle and limit to 10 when no query (initial suggestions)
  if (!query && doctors.length > 10) {
    doctors = doctors.sort(function() { return 0.5 - Math.random(); }).slice(0, 10);
  }
  return doctors;
}

export async function searchTags(query, context) {
  var url = '/api/tags?per_page=20';
  if (query) url += '&q=' + encodeURIComponent(query);
  if (context) url += '&context=' + encodeURIComponent(context);
  var res = await fetch(url);
  var json = await res.json();
  // FastJsonAPI format: { data: [{ id, type, attributes: { name } }] }
  if (json.data && Array.isArray(json.data)) {
    return json.data.map(function(t) {
      if (t.attributes && t.attributes.name) return t.attributes.name;
      if (t.name) return t.name;
      return t;
    });
  }
  // Fallback: array of attribute hashes from to_h
  if (Array.isArray(json)) {
    return json.map(function(t) { return t.name || t; });
  }
  return [];
}
